import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";

const stories = [
    {
        title: "Watershed Development — Sangli & Satara",
        partner: "CSR Partner — Leading FMCG Company",
        summary: "Construction of 120+ water harvesting structures across drought-prone villages, increasing groundwater recharge by 40% and benefiting over 15,000 farming families.",
        outcome: "3,200 hectares of agricultural land brought under protective irrigation.",
        image: "/images/impact/watershed.jpg",
    },
    {
        title: "Women's Empowerment through SHGs",
        partner: "CSR Partner — National Bank",
        summary: "Formation and capacity building of 250+ Self-Help Groups empowering rural women with financial literacy, micro-enterprise development, and market linkages.",
        outcome: "5,000+ women trained; cumulative savings exceeding ₹2.5 crore.",
        image: "/images/impact/women_empowerment.jpg",
    },
    {
        title: "Organic Farming Transition — Kolhapur",
        partner: "CSR Partner — Agribusiness Corporation",
        summary: "Supported 800+ farmers in transitioning to chemical-free agriculture through training, soil testing, and organic input supply chains.",
        outcome: "30% increase in net farm income; 1,500 acres converted to organic cultivation.",
        image: "/images/impact/organic_farming.jpg",
    },
    {
        title: "Sanitation & Hygiene — Palghar & Raigad",
        partner: "CSR Partner — Multinational Pharmaceutical",
        summary: "Built 2,000+ individual household toilets and community sanitation blocks, coupled with behaviour-change campaigns across tribal villages.",
        outcome: "12 Gram Panchayats declared Open Defecation Free (ODF).",
        image: "/images/impact/sanitation.jpg",
    },
    {
        title: "Climate Resilience — Drought Mitigation",
        partner: "CSR Partner — Energy Sector PSU",
        summary: "Integrated drought mitigation program across 45 villages combining farm ponds, reforestation, and climate-smart agricultural practices.",
        outcome: "Groundwater levels rose by 2–3 metres; crop loss reduced by 50%.",
        image: "/images/impact/climate_action.jpg",
    },
    {
        title: "Skill Development & Livelihood",
        partner: "CSR Partner — IT Services Company",
        summary: "Vocational training for 1,200 rural youth in agriculture technology, dairy management, and micro-enterprise skills with placement support.",
        outcome: "85% placement rate; average income increase of 60%.",
        image: "/images/impact/livelihood.jpg",
    },
];

const CsrSuccessStories = ({ darkMode }) => {
    return (
        <div style={{ paddingTop: "80px" }}>
            <div style={{
                background: "linear-gradient(135deg, #1B5E20, #388E3C, #4CAF50)",
                padding: "60px 0 50px",
                color: "#fff",
                textAlign: "center",
            }}>
                <Container>
                    <motion.h1
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        style={{ fontWeight: "800", marginBottom: "16px" }}
                    >
                        CSR Success Stories
                    </motion.h1>
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.15 }}
                        style={{ maxWidth: "720px", margin: "0 auto", fontSize: "1.1rem", opacity: 0.92 }}
                    >
                        Impactful partnerships between PSGS and corporate partners driving sustainable change
                        in rural Maharashtra through targeted CSR investments.
                    </motion.p>
                </Container>
            </div>

            <Container style={{ padding: "50px 0 60px" }}>
                {stories.map((story, i) => (
                    <motion.div
                        key={i}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: i * 0.06 }}
                    >
                        <Card className="mb-4 shadow-sm" style={{
                            border: "none",
                            borderRadius: "12px",
                            overflow: "hidden",
                            backgroundColor: darkMode ? "#2c3034" : "#fff",
                        }}>
                            <Row className="g-0 align-items-center">
                                <Col md={4}>
                                    <div style={{
                                        height: "220px",
                                        background: `linear-gradient(135deg, ${i % 2 === 0 ? '#C8E6C9' : '#E8F5E9'} 0%, ${i % 2 === 0 ? '#A5D6A7' : '#C8E6C9'} 100%)`,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}>
                                        <span style={{ fontSize: "4rem", opacity: 0.4 }}>
                                            {["🌊", "👩‍🌾", "🌱", "🚿", "☀️", "📈"][i]}
                                        </span>
                                    </div>
                                </Col>
                                <Col md={8}>
                                    <Card.Body style={{ padding: "28px 32px" }}>
                                        <div style={{
                                            fontSize: "0.78rem",
                                            fontWeight: "600",
                                            color: "#4CAF50",
                                            textTransform: "uppercase",
                                            letterSpacing: "0.5px",
                                            marginBottom: "6px",
                                        }}>
                                            {story.partner}
                                        </div>
                                        <Card.Title style={{
                                            fontWeight: "700",
                                            fontSize: "1.15rem",
                                            color: "#2E7D32",
                                            marginBottom: "10px",
                                        }}>
                                            {story.title}
                                        </Card.Title>
                                        <Card.Text style={{
                                            fontSize: "0.92rem",
                                            color: darkMode ? "#ccc" : "#555",
                                            lineHeight: "1.7",
                                            marginBottom: "12px",
                                        }}>
                                            {story.summary}
                                        </Card.Text>
                                        <div style={{
                                            backgroundColor: "#E8F5E9",
                                            borderRadius: "8px",
                                            padding: "10px 16px",
                                            fontSize: "0.88rem",
                                            color: "#1B5E20",
                                            fontWeight: "600",
                                        }}>
                                            Outcome: {story.outcome}
                                        </div>
                                    </Card.Body>
                                </Col>
                            </Row>
                        </Card>
                    </motion.div>
                ))}
            </Container>
        </div>
    );
};

export default CsrSuccessStories;
